import React, {useEffect, useState} from 'react'
import TodoForm from "../components/TodoForm"
import TodoList from "../components/TodoList"
import {ITodo} from "../interfaces"

declare var confirm: (question: string) => boolean

const TodosPage: React.FC = () => {
  const [todos, setTodos] = useState<ITodo[]>([])

  useEffect(() => {
    const savedTodos = JSON.parse(localStorage.getItem('todos') || '[]') as ITodo[]
    setTodos(savedTodos)
  }, [])

  useEffect(() => {
    localStorage.setItem('todos', JSON.stringify(todos))
  }, [todos])

  const addTodoHandler = (title: string) => {
    const newTodo: ITodo = {
      title,
      id: Date.now(),
      completed: false
    }

    setTodos(todos => [newTodo, ...todos])
  }

  const toggleTodoHandler = (id: number) => {
    setTodos(prev => prev.map(todo => {
      if (todo.id === id) {
        return {
          ...todo,
          completed: !todo.completed
        }
      }
      return todo
    }))
  }

  const removeTodoHandler = (id: number) => {
    if (confirm('Вы уверены, что хотите удалить задачу?')) {
      setTodos(todos => todos.filter(todo => todo.id !== id))
    }
  }

  return (
    <>
      <TodoForm onAdd={addTodoHandler}/>
      <TodoList
        todos={todos}
        toggleTodo={toggleTodoHandler}
        removeTodo={removeTodoHandler}
      />
    </>
  )
}

export default TodosPage
